var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#E4EFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    stroke: "#202020",
    strokeOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.924 20C47.832 20 52.924 25.088 52.924 32C52.924 38.912 47.832 44 40.924 44C34.02 44 28.924 38.912 28.924 32C28.924 25.088 34.02 20 40.924 20ZM20.5 59.088C24.088 53.808 30.072 50.288 36.924 50.288H44.924C51.78 50.288 57.76 53.808 61.348 59.088C56.236 64.56 48.984 68 40.924 68C32.864 68 25.612 64.56 20.5 59.088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.bd8e6ac3bf6b4c938f8d6b8541b3300a.svg";
export { ForwardRef as ReactComponent };